




import Vue from 'vue';
import ProcessingStatusOrganizationsList from '@/components/processing-status-organizations/processing-status-organizations-list.component.vue';

export default Vue.extend({
  components: {
    'processing-status-organizations-list': ProcessingStatusOrganizationsList,
  },
});
